import { axios, AxiosResponse } from '~/modules'
import { OncologyDiagnosesFetchParams, IOncologyDiagnosis } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchOncologyDiagnoses = async (params: OncologyDiagnosesFetchParams): Promise<IOncologyDiagnosis> => {
  const { pathParams } = params
  const response = await axios.get(`${hstoryAPI}/oncology-diagnoses/${pathParams.diagnosisId}`)
  const { data }: AxiosResponse<IOncologyDiagnosis> = response
  return data
}
